import { BrowserRouter, Routes, Route, Link,useParams } from "react-router-dom"

// pages

import Login from "../Pages/Common/Login"
import Home from "../Pages/Common/Home"
import NoAccessLicence from "../Pages/Common/NoAccessLicence";
import WaitingRoomForNewUser from "../Pages/Common/WaitingRoomForNewUser";

import ManagerAdministration from "../Pages/Manager/ManagerAdministration";
import ManagerGateKeeper from "../Pages/Manager/ManagerGateKeeper";
import ManagerReports from "../Pages/Manager/ManagerReports";
import ManagerProfile from "../Pages/Manager/ManagerProfile";
import ManagerWarehouse from "../Pages/Manager/ManagerWarehouse";
import ManagerOrders from "../Pages/Manager/ManagerOrders";
import ManagerSettlements from "../Pages/Manager/ManagerSettlements";

import WorkerDevices from "../Pages/Worker/WorkerDevices";
import WorkerGateKeeper from "../Pages/Worker/WorkerGateKeeper";
import WorkerProfile from "../Pages/Worker/WorkerProfile";
import WorkerDevice from "../Pages/Worker/WorkerDevice";

import DriverGateKeeper from "../Pages/Driver/DriverGateKeeper";
import DriverProfile from "../Pages/Driver/DriverProfile";

function Routing() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/Home" element={<Home />} />
        <Route path="/NoAccessLicence" element={<NoAccessLicence />} />
        <Route path="/WaitingRoomForNewUser" element={<WaitingRoomForNewUser />} />

        <Route path="/ManagerOrders" element={<ManagerOrders />}/>
        <Route path="/ManagerAdministration" element={<ManagerAdministration />} />
        <Route path="/ManagerGateKeeper" element={<ManagerGateKeeper />} />
        <Route path="/ManagerSettlements" element={<ManagerSettlements />} />
        <Route path="/ManagerReports" element={<ManagerReports />} />
        <Route path="/ManagerProfile" element={<ManagerProfile />} />

        <Route path="/ManagerWarehouse" element={<ManagerWarehouse />} />

        <Route path="/workerDevices" element={<WorkerDevices />} />
        <Route path="/workerGateKeeper" element={<WorkerGateKeeper />} />
        <Route path="/WorkerProfile" element={<WorkerProfile />} />
        <Route path="/WorkerDevice/:id" element={<WorkerDevice />} />

        <Route path="/driverGateKeeper" element={<DriverGateKeeper />} />
        <Route path="/DriverProfile" element={<DriverProfile />} />


      </Routes>
    </BrowserRouter>
  );
}

export default Routing;
